import {Discount} from '../config/discount';
import { Product } from '../config/product';
import { ProductType } from '../config/product-type';
import { Provider } from './provider';

export class DiscountProvider extends Provider {
    multipleDiscount = false;
    reqDiscountCounter = 0;
    maxReqDiscountCounter = 0;
    amountDiscounted = 0;

    getDiscount(config: any, code: string, formId?: string, selectedSubs?: string[] ): Promise<any> {
        let url = '';
        switch (config.discountUrl) {
            case '&code=':
                url = this.getDiscountUrl(config.host, config.portalId) + config.discountUrl + encodeURIComponent(code) + (formId ? '&formId=' + formId : '');
                return this.fetch(url)
                    .then((response: any) => {
                        if (!response) {
                            return Promise.reject({error: response, type: 'discountId', emptyCoupon: true});
                        }
                        return Promise.resolve({response: response, type: 'discountUrl'});
                    });
            case '&couponId=':
                url = this.getSubscriptionDiscountUrl(config.host, config.portalId, config.accountId, selectedSubs) + config.discountUrl + encodeURIComponent(code);
                return this.fetch(url)
                    .then((response: any) => {
                        if (!response.discount && !response.stripeCoupon) {
                            return Promise.reject({error: response, type: 'couponId', emptyCoupon: true});
                        }
                        return Promise.resolve({response: response, type: 'couponUrl'});
                    });
            default:
                return Promise.reject({ok: false});
        }
    }

    private getDiscountUrl(host: string, portalId: string): string {
        return `${host}pub/v3/discounts/?portalId=${portalId}`;
    }

    private getSubscriptionDiscountUrl(host: string, portalId: string, accountId?: string, selectedSubs?: string[]): string {
        let url = `${host}pub/v2/subscription/discounts?portalId=${portalId}`;
        if (accountId) {
            url += `&accountId=${accountId}`;
        }

        if (selectedSubs) {
            url += '&plans=';
            selectedSubs.forEach((x, i) => url += `${x}${i !== selectedSubs.length - 1 ? ',' : ''}`);
        }
        return url;
    }

    getDiscountType(products: Array<Product>): Array<any> {
        let both: Array<string> = [];
        let discountTypes: Array<any> = products.map((product: Product) => {
            switch (product.type) {
                case ProductType.SINGLE_PAYMENT:
                    return 'discount';
                case ProductType.SUBSCRIPTION:
                    return 'stripeDiscount';
                case ProductType.DONATION:
                    both = both.concat(['discount', 'stripeDiscount']);
                    return 'discount';
            }
        });
        discountTypes = discountTypes.concat(both);
        discountTypes = discountTypes.filter((v, i, a) => {
            if (v) {
                return a.indexOf(v) === i;
            }
        });
        this.maxReqDiscountCounter = discountTypes.length;
        return discountTypes;
    }

}
